import React, { useState, useEffect, useCallback } from 'react';
import Table from '../components/table/table';
import SubNav from '../components/subNav/subNav';
import TeamsData from '../data/teams.json';
const { teamsData } = { ...TeamsData }
import DisplayModal from '../modals/displayModal/displayModal';
import { createTeamData, updateTeamData, fetchTeamData, deleteTeamData, fetchTeamGlobalSearchData, fetchTeamsDropdownOptionList } from '../api/teamsApi';
import Loader from '../components/loader/loader';
import { exportToExcel } from '../functions/exportToExcel';
import debouce from 'lodash/debounce';
import handle_toast  from '../genericFunctions/toast_Handler';

const Team = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [dataFetched, setDataFlag] = useState(false);
  const [teamData, setTeamData] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  const accessData = sessionStorage.getItem('accessData') ? JSON.parse(sessionStorage.getItem('accessData'))['Team Management'] : {};
  // debounce call
  const debouncedCall = useCallback(
    debouce(()=> {
      fetchTeams();
    }, 500), //Adjusting the delay
    []
  );

  const toggleModal = () => {
    setModalVisible(!modalVisible);
  }

  useEffect(() => {
    if (!dataFetched) debouncedCall();

    //Clean up the debounce on component unmount
    return () => {
      debouncedCall.cancel();
    };
  }, [dataFetched, debouncedCall]);

  const fetchTeams = async () => {
    try {
      setDataFlag(true);
      const resp = await fetchTeamData();
      setIsLoading(false);
      setTeamData(resp?.data?.teamData);
      handle_toast({message: `Teams data fetched`, status: 'success'})
      if (modalVisible) toggleModal();
    }
    catch (error) {
      setDataFlag(true);
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const fetchTeamsDropdownOptionListData = async () => {
    try {
      const dropDownData = sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')) : {};
      const resp = await fetchTeamsDropdownOptionList();
      const userFormat = [];
      resp?.data?.teamsList?.map((obj) => {
        userFormat.push({name: obj.name, id: obj.id, sesaId: obj.sesaId, email: obj.email, checked: false}) 
      })
      dropDownData.Teams = userFormat;
      sessionStorage.setItem('dropDownData', JSON.stringify(dropDownData));
      handle_toast({message: `Data Fetched`, status: 'success'})
    }
    catch (error) {
      handle_toast(error)
    }
  }

  const fetchGlobalSearch = async (query) => {
    try {
      const resp = await fetchTeamGlobalSearchData(query);
      setIsLoading(false);
      setDataFlag(true)
      setTeamData(resp?.data?.globalSearchData);
      handle_toast({message: `Filtered teams data fetched`, status: 'success'})
    }
    catch (error) {
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }

  const handleSave = async (formData) => {
    setIsLoading(true)
    try {
      const resp = await createTeamData(formData)
      if (resp?.status == 200) {
        handle_toast({message: `Team created`, status: 'success'})
        fetchTeams();
        fetchTeamsDropdownOptionListData();
      }
    }
    catch (error) {
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const handleEdit = async (formData) => {
    setIsLoading(true)
    try {
      const resp = await updateTeamData(formData)
      if (resp) {
        handle_toast({message: `Team updated`, status: 'success'})
        fetchTeams();
        fetchTeamsDropdownOptionListData();
      }
    }
    catch (error) {
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const handleDelete = async (formData) => {
    setIsLoading(true)
    try {
      const resp = await deleteTeamData(formData)
      if (resp?.status == 200) {
        handle_toast({message: `Team deleted`, status: 'success'})
        fetchTeams();
        fetchTeamsDropdownOptionListData();
      }
    }
    catch (error) {
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const excelExport = () => {
    exportToExcel(teamData, teamsData.teamsHeaders, 'Team')
  }

  return (
    <>

      <div className='componentContainer'>
        {isLoading && <Loader />}
        {!isLoading && <SubNav data={teamsData.teamsSubNav} access={accessData} handleModalClick={toggleModal} sendReset={fetchTeams} excelExport={excelExport} handleDDSearch={fetchGlobalSearch}></SubNav>}
        <se-container>
          <se-divider option='vertical'></se-divider>
          <div className='tableContainer'>
            {
              <Table columns={teamsData.teamsHeaders} access={accessData} loginRestriction={true} body={teamData} modalData={teamsData.teamsModalData} onSave={handleEdit} onDelete={handleDelete} page='teams' selection={false}/>
            }
          </div>
        </se-container>
        {modalVisible && <DisplayModal toggleModal={toggleModal} data={teamsData.teamsModalData} source="create" onSave={handleSave} page="teams" completeJson = {teamsData} />}
      </div>
    </>
  );
};
export default Team;

